import classNames from 'classnames';
import React from 'react';
import { Checkbox } from '../Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TableAlignment;

(function (TableAlignment) {
  TableAlignment["Left"] = "left";
  TableAlignment["Right"] = "right";
})(TableAlignment || (TableAlignment = {}));

/**
 * Converts rows to tabular data
 * @param columns Table column data
 * @param rows Table row data
 * @param idField The name of the field that uniquely identifies data in a row
 */
// eslint-disable-next-line
function convertToTabularData(columns, rows, idField) {
  var result = {};
  rows.forEach(function (row) {
    var singeRow = [];
    columns.forEach(function (column) {
      singeRow.push(row[column.name]);
    });
    result[row[idField]] = singeRow;
  });
  return result;
}

export var Table = function Table(_ref) {
  var columns = _ref.columns,
      rows = _ref.rows,
      rowClassNames = _ref.rowClassNames,
      tableClassNames = _ref.tableClassNames,
      tableDataClassNames = _ref.tableDataClassNames,
      isSelectable = _ref.isSelectable,
      idField = _ref.idField,
      selectedRows = _ref.selectedRows,
      selectAllActive = _ref.selectAllActive,
      renderCell = _ref.renderCell,
      onSelectAllClick = _ref.onSelectAllClick,
      onSelectRowClick = _ref.onSelectRowClick,
      hideColumn = _ref.hideColumn;
  var tabularData = convertToTabularData(columns, rows, idField);
  return /*#__PURE__*/_jsx("div", {
    className: "shadow overflow-x-auto no-scrollbar sm:overflow-hidden border-b border-gray-200 rounded-lg rounded-t-none",
    children: /*#__PURE__*/_jsxs("table", {
      className: tableClassNames,
      style: {
        borderCollapse: 'collapse'
      },
      children: [/*#__PURE__*/_jsx("thead", {
        className: "bg-gray-100",
        children: /*#__PURE__*/_jsxs("tr", {
          children: [isSelectable && /*#__PURE__*/_jsx("th", {
            className: "flex flex-grow text-gray-500 uppercase text-sm font-medium w-4",
            children: /*#__PURE__*/_jsx("label", {
              className: "flex p-4 clickable",
              style: {
                width: '100%'
              },
              children: /*#__PURE__*/_jsx(Checkbox, {
                checked: selectAllActive,
                onChange: function onChange(name, isChecked) {
                  return onSelectAllClick && onSelectAllClick(isChecked);
                }
              })
            })
          }), columns.map(function (column) {
            return /*#__PURE__*/_jsx("th", {
              className: classNames('md:p-4 mr-auto m1 mr0', {
                'text-left': column.alignment === TableAlignment.Left,
                'text-right': column.alignment === TableAlignment.Right,
                clickable: Boolean(column.onClick)
              }),
              onClick: column.onClick,
              style: {
                width: column.width
              },
              children: /*#__PURE__*/_jsxs("div", {
                className: classNames('flex justify-between'),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: classNames('flex flex-grow text-gray-500 uppercase text-sm font-medium', {
                    'justify-end': column.alignment === TableAlignment.Right,
                    'hidden md:block': hideColumn === null || hideColumn === void 0 ? void 0 : hideColumn.includes(column.title)
                  }),
                  children: [column.iconLeft && /*#__PURE__*/_jsx("span", {
                    className: "mr-2",
                    children: column.iconLeft
                  }), column.title]
                }), column.iconRight && /*#__PURE__*/_jsx("span", {
                  className: "ml-2 ",
                  children: column.iconRight
                })]
              })
            }, column.key || column.name);
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: Object.keys(tabularData).map(function (rowId, i) {
          return /*#__PURE__*/_jsxs("tr", {
            className: rowClassNames,
            onClick: function onClick() {
              return onSelectRowClick && onSelectRowClick(i);
            },
            children: [isSelectable && /*#__PURE__*/_jsx("td", {
              style: {
                width: 16
              },
              children: /*#__PURE__*/_jsx("label", {
                className: "flex p-4 clickable",
                children: /*#__PURE__*/_jsx(Checkbox, {
                  checked: selectAllActive || selectedRows && selectedRows.indexOf(rowId) > -1,
                  onChange: function onChange(name, isChecked) {
                    return onSelectRowClick && onSelectRowClick(rowId, isChecked);
                  }
                })
              })
            }), tabularData[rowId].map(function (data, j) {
              return /*#__PURE__*/_jsx("td", {
                className: classNames("".concat(tableDataClassNames), {
                  'text-left': columns[j].alignment === TableAlignment.Left,
                  'text-right': columns[j].alignment === TableAlignment.Right
                }),
                style: {
                  width: columns[j].width
                },
                children: columns[j].renderCell ? columns[j].renderCell(data) : renderCell ? renderCell(data) : data
              }, "table-data-".concat(i).concat(j));
            })]
          }, rowId);
        })
      })]
    })
  });
};
Table.defaultProps = {
  idField: 'id',
  tableClassNames: 'w-fill',
  rowClassNames: 'border border-gray-200 fw-500 h4  rounded-t-none last:rounded-lg',
  tableDataClassNames: 'p-4 mr-auto m1 mr0 text-neutral-400 font-normal'
};